import React from "react"
import ReactDOM from "react-dom"
import "intl-tel-input/build/css/intlTelInput.css"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Router } from "react-router-dom"
import { createBrowserHistory } from "history"
import { HubspotChatProvider } from "./context/HubspotChatContext"

const history = createBrowserHistory()

ReactDOM.render(
  <React.StrictMode>
    <Router history={history} /* onChange={this.onChangeRouter()} */>
        <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
